import { useQuery } from "@tanstack/react-query";
import { getSupervisors } from "../api/licenseApplicationApi";
import { licenseApplicationKeys } from "../api/licenseApplicationKeys";

export const useSupervisors = () =>
  useQuery({
    queryKey: licenseApplicationKeys.supervisors(),
    queryFn: getSupervisors,
  });
